import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import {
  CountryRecyclability,
  CountryRecyclabilityRecyclingStatus,
} from '../../../../types/recyclability'
import { COUNTRY_RECYCLABILITY_OPTIONS } from '../../../../constants/country-recyclability'
import { TranslationService } from '../../../../services/translation.service'
import { NgOptimizedImage } from '@angular/common'

@Component({
  selector: 'app-country-recyclability-highlight',
  imports: [NgOptimizedImage],
  templateUrl: './country-recyclability-highlight.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './country-recyclability-highlight.component.scss',
})
export class CountryRecyclabilityHighlightComponent implements OnChanges {
  translationService = inject(TranslationService)

  @Input({ required: true }) countryRecyclability?: CountryRecyclability
  recyclabilityStatus?: CountryRecyclabilityRecyclingStatus

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['countryRecyclability'] &&
      changes['countryRecyclability'].currentValue
    ) {
      if (this.countryRecyclability) {
        const recyclabilityOption = COUNTRY_RECYCLABILITY_OPTIONS.find(
          (option) => option.country === this.countryRecyclability?.country,
        )

        this.recyclabilityStatus =
          recyclabilityOption?.recyclabilityStatuses.find(
            (status) =>
              status.name === this.countryRecyclability!.recyclabilityStatus,
          )
      }
    }
  }
}
